import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> IOT </li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>IOT (Internet of Things) Security Testing</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  The Internet of Things (IoT) has revolutionized industries by
                  connecting devices, sensors, and applications into a seamless
                  ecosystem. However, this connectivity also introduces new
                  attack surfaces and vulnerabilities. IoT Security Testing
                  ensures that your devices, applications, and supporting
                  infrastructure are safeguarded against cyber threats that
                  could compromise data, operations, and customer trust.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                {[
                  {
                    icon: "fa-arrows-down-to-people",
                    title: "Explosive Growth of IoT",
                    desc: "Billions of IoT devices are deployed across healthcare, manufacturing, smart homes, automotive, and industrial sectors — each a potential entry point for attackers."
                  },
                  {
                    icon: "fa-database",
                    title: "Weak Default Security",
                    desc: "Many IoT devices ship with insecure defaults, weak authentication, and outdated firmware."
                  },
                  {
                    icon: "fa-shield-halved",
                    title: "High-Stakes Impact",
                    desc: "An exploited IoT vulnerability can disrupt operations, cause physical damage, or leak sensitive data."
                  },
                  {
                    icon: "fa-table",
                    title: "Compliance Demands",
                    desc: "Regulatory standards such as GDPR, HIPAA, ISO 27001, and NIST IoT Cybersecurity Framework require strong IoT security practices."
                  },
                  {
                    icon: "fa-business-time",
                    title: "Trust & Reputation",
                    desc: "For organizations delivering IoT solutions, strong security is not optional — it is a differentiator that wins client confidence."
                  },
                ].map((item, i) => (
                  <div className="service-box" key={i}>
                    <div className="service-icon">
                      <i className={`fa-solid ${item.icon}`}></i>
                    </div>
                    <div className="service-card-content">
                      <h3>{item.title}</h3>
                      <p>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    {[
                      { id: "methodology", label: "Methodology" },
                      { id: "keybenefits", label: "Key Benefits" },
                      { id: "deliverables", label: "Deliverables" },
                    ].map((tab) => (
                      <li className="nav-item" key={tab.id}>
                        <button
                          className={`nav-link${activeTab === tab.id ? " active" : ""}`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          {tab.label}
                        </button>
                      </li>
                    ))}
                  </ul>

                  <div className="tab-content">
                    {/* Methodology */}
                    <div className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`} role="tabpanel">
                      <p>
                        Our IoT Security Testing methodology is designed to address vulnerabilities across the device, application, communication, and cloud ecosystem:
                      </p>
                      <ul>
                        <li><b>Device Assessment :-</b> Review hardware, firmware, and operating system for backdoors, weak configurations, and unpatched flaws.</li>
                        <li><b>Network Security Analysis :-</b> Evaluate communication protocols (MQTT, CoAP, Bluetooth, Zigbee, Wi-Fi, etc.) for encryption, authentication, and data leakage.</li>
                        <li><b>Firmware & Binary Review :-</b> Reverse engineering and analysis of firmware to detect hidden vulnerabilities or malicious code.</li>
                        <li><b>Application Testing :-</b> Assess companion mobile/web apps for insecure APIs, data storage issues, and authentication weaknesses.</li>
                        <li><b>Cloud & Backend Review :-</b> Examine IoT cloud infrastructure, APIs, and databases for misconfigurations and access control gaps.</li>
                        <li><b>Penetration Simulation :-</b> Perform real-world attack simulations including spoofing, replay attacks, privilege escalation, and DoS attempts.</li>
                        <li><b>Compliance Mapping :-</b> Align security checks with OWASP IoT Top 10, NIST, and industry standards.</li>
                      </ul>
                    </div>

                    {/* Key Benefits */}
                    <div className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`} role="tabpanel">
                      <ul>
                        <li>Protection against device hijacking, data theft, and service disruption.</li>
                        <li>Enhanced consumer trust and brand reputation.</li>
                        <li>Stronger regulatory compliance and reduced legal exposure.</li>
                        <li>Proactive identification of zero-day vulnerabilities in devices and apps.</li>
                        <li>Improved security posture across IoT supply chain and lifecycle.</li>
                        <li>Confidence to scale IoT deployments securely.</li>
                      </ul>
                    </div>

                    {/* Deliverables */}
                    <div className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`} role="tabpanel">
                      <p>With our IoT Security Testing service, you receive:</p>
                      <ul>
                        <li><b>Comprehensive Security Report :-</b> Identified vulnerabilities with risk ratings and impact details.</li>
                        <li><b>Remediation Roadmap :-</b> Practical fixes for firmware, apps, network, and cloud components.</li>
                        <li><b>Compliance Gap Analysis :-</b> Mapping against OWASP IoT Top 10, NIST IoT Cybersecurity Framework, ISO, and sector-specific standards.</li>
                        <li><b>Executive Summary :-</b> Clear, non-technical findings for leadership teams.</li>
                        <li><b>Remediation Assistance :-</b> Guidance sessions with development and engineering teams.</li>
                        <li><b>Validation Testing (Optional) :-</b> Post-fix verification to ensure vulnerabilities are resolved.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach </h3>
                  <p>We deliver end-to-end IoT security expertise with a client-focused mindset:</p>
                  <ul>
                    <li><b>Holistic Coverage :-</b> Testing across device hardware, firmware, communication, apps, and cloud services.</li>
                    <li><b>Industry Experience :-</b> Securing IoT ecosystems in smart cities, automotive, healthcare, industrial IoT, and consumer devices.</li>
                    <li><b>Deep Technical Expertise :-</b> Specialists in embedded systems, reverse engineering, and protocol security.</li>
                    <li><b>Business-Centric Reporting :-</b> Actionable insights that balance security and operational feasibility.</li>
                    <li><b>Custom Test Cases :-</b> Tailored assessments based on device use cases, threat models, and compliance requirements.</li>
                    <li><b>Beyond Testing :-</b> We don’t just detect vulnerabilities — we provide remediation strategies and secure development guidance.</li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
